export default {
      id: "tires-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#tires-usage",
      toString: function () {
        return this.url;
      }
    }